/// <amd-module name="VC/Markdown/Plugins/VCLinkTransformer" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */
import { Uri } from "VSS/Platform/Util/Url";
import { TfvcVersionControlPathUtility } from "VC/Markdown/Plugins/PathUtilities/TfvcVersionControlPathUtility";
import { GitVersionControlPathUtility } from "VC/Markdown/Plugins/PathUtilities/GitVersionControlPathUtility";
import * as VersionControlUrlUtilities from "VC/Markdown/Plugins/PathUtilities/VersionControlUrlUtilities";

import * as Git from "VC/Common/Contracts/Git";
import { IVssPageContext } from 'VSS/Platform/Context';
import { TfvcVersionControlPath } from "./PathUtilities/TfvcVersionControlPath";
import * as VersionControlPath from "./PathUtilities/VersionControlPath";


export namespace VersionControlActionIds {
    export const Contents = "contents";
    export const Compare = "compare";
    export const Default = "";
    export const History = "history";
    export const Preview = "preview";

}
export class VCLinkTransformer {

    constructor(
        private repositoryType: VersionControlUrlUtilities.RepositoryType,
        private item: Git.ItemModel,
        private repositoryId: string,
        private projectName: string,
        private context: IVssPageContext,
        private version?: string
    ) { }

    public transformLink = (src: string): string => {
        try {
            new Uri(src, { absoluteUriRequired: true });
            return src;
        } catch(e) {}
        let path = new Uri(src); //Performs decoding

        return this.transformRelativeLink(path);
    }

    private transformRelativeLink(uri: Uri): string {
        let path: string = "";
        if (uri && uri.path.length > 0) {
            path = uri.path;
        }

        let anchorName = uri.hashString;

        let versionControlPath: string;
        if (this.repositoryType == VersionControlUrlUtilities.RepositoryType.Git) {

            versionControlPath = this.getGitVersionControlPath(path);
        }
        else if (this.repositoryType == VersionControlUrlUtilities.RepositoryType.Tfvc) {

            versionControlPath = this.getTfsVersionControlPath(path);
        }
        else {
            return path;
        }

        let browserUri = this.getBrowserUri(versionControlPath, anchorName);
        return browserUri;
    }

    private getGitVersionControlPath(href: string): string {
        let versionControlPath = GitVersionControlPathUtility.combine(this.item.path, href);
        return versionControlPath;
    }

    private getTfsVersionControlPath(href: string): string {
        let versionControlPath = "";
        try {
            versionControlPath = TfvcVersionControlPathUtility.combine(this.item.path, href);
        }
        catch (e) {
            console.log(e);
        }

        return versionControlPath;
    }

    private getBrowserUri(uri: string, anchorName?: string): string {

        let state: any;
        let routeData: any = null;

        if (this.repositoryType === VersionControlUrlUtilities.RepositoryType.Git) {

            state = { path: uri, version: this.version, project: this.projectName, "vc.GitRepositoryName": this.repositoryId };
        }
        else if (this.repositoryType === VersionControlUrlUtilities.RepositoryType.Tfvc) {

            state = { path: uri };

            let currentProject = new TfvcVersionControlPath(this.item.path).getProjectName();
            let newProject = new TfvcVersionControlPath(uri).getProjectName();

            if (newProject && currentProject && newProject !== currentProject) {
                routeData = { project: newProject };
            } else {
                routeData = { project: currentProject };
            }
        }
        else {

            throw new Error("Repository type must be one of {Git, TFS}");
        }

        let action = VersionControlActionIds.Contents;
        let fileExtension: string = VersionControlPath.getFileExtension(uri.toLowerCase());
        if (fileExtension === "md") {
            action = VersionControlActionIds.Preview;
        }
        if (anchorName) {
            state.anchor = anchorName;
        }

        return VersionControlUrlUtilities.getExplorerUrl(this.context, this.repositoryType, uri, action, state, routeData);
    }

}
